import { emosLightTheme } from './emosLightTheme'

export * from './emosLightTheme'

export default emosLightTheme
